const features = [
  {
    icon: 'ri-stack-line',
    title: '多平台聚合',
    desc: '一站聚合红桃视频、樱花视频、糖豆视频等6+特色视频平台内容，告别切换多个App的繁琐，发现更多精彩影视资源。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: '高清不缓冲',
    desc: '智能CDN加速和多线路冗余技术保障，无论网络环境如何变化，始终保持高清流畅的播放体验。芭乐视频高清，在线不缓冲，专注您的观影享受。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '芭乐视频仅做内容聚合推荐，不存储任何视频文件，所有播放均跳转至源平台官方页面。安全绿色，无需担心恶意弹窗或隐私泄露。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">平台特色</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为什么选择芭乐视频作为观影入口</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-2xl ${feat.color} flex items-center justify-center mx-auto`}>
                <i className={`${feat.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="mt-5 text-base md:text-lg font-heading font-bold text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}